<template>
  <div>
    <!-- 
			Info
		-->
    <roomInfo ref="roomInfo" class="mb-24" />

    <!--
			Option
		-->
    <a-tabs default-active-key="1" @change="onTabChanged">
      <a-tab-pane key="1">
        <span slot="tab">
          <a-icon type="history" />
          Access Log
        </span>
        <aclTable ref="aclTable" class="mb-24" />
      </a-tab-pane>
      <a-tab-pane key="2" forceRender>
        <span slot="tab">
          <a-icon type="unordered-list" />
          User Whitelist
        </span>
        <rwlUserTable ref="rwlUserTable" class="mb-24" />
      </a-tab-pane>
      <a-tab-pane key="3" forceRender>
        <span slot="tab">
          <a-icon type="unordered-list" />
          Group Whitelist
        </span>
        <rwlGroupTable ref="rwlGroupTable" class="mb-24" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import axios from "axios";
import aclTable from "../../components/Inventories/ACLTable";
import rwlUserTable from "../../components/Inventories/RWLUserTable";
import rwlGroupTable from "../../components/Inventories/RWLGroupTable";
import roomInfo from "../../components/Inventories/RoomInfo";
import tools from "../../utils/tools";

export default {
  //
  //
  //
  components: {
    aclTable,
    rwlUserTable,
    rwlGroupTable,
    roomInfo
  },
  //
  //
  //
  data() {
    return {
      room: null
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  created() { },
  //
  //
  //
  beforeMounted() { },
  //
  //
  //
  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      return;
    }
    // Request room's info.
    this.requestData();
  },
  //
  //
  //
  beforeUpdated() { },
  //
  //
  //
  updated() { },
  //
  //
  //
  beforeDestroy() { },
  //
  //
  //
  destroyed() { },
  //
  //
  //
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    // Request data.
    //
    async requestData() {
      axios
        .get(
          process.env.VUE_APP_INVENTORY_API +
          "/rooms/get/" +
          this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          //
          this.room = response.data.data;
          //
          this.$refs.aclTable.setQuery("room=" + this.room.name);
          this.$refs.aclTable.requestData();
          //
          this.$refs.roomInfo.setInfo(this.room);
        })
        .catch(error => {
          console.log(error);
        });
    },
    //
    //
    //
    async onTabChanged(key) {
      if (key === "1") {
        this.$refs.aclTable.setQuery("room=" + this.room.name);
        this.$refs.aclTable.requestData();
      } else if (key === "2") {
        this.$refs.rwlUserTable.setQuery("roomId=" + this.room._id);
        this.$refs.rwlUserTable.setInfo(this.room);
        this.$refs.rwlUserTable.requestData();
      } else if (key === "3") {
        this.$refs.rwlGroupTable.setQuery("roomId=" + this.room._id);
        this.$refs.rwlGroupTable.setInfo(this.room);
        this.$refs.rwlGroupTable.requestData();
      }
    }
  }
};
</script>

<style lang="scss">
table>tbody>tr {
  vertical-align: top;
}
</style>
